import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Se não estiver autenticado, redirecionar para login normal
    if (!loading && !user) {
      navigate('/login');
      return;
    }

    // Se não for admin, redirecionar para dashboard
    if (!loading && user && !user.isAdmin) {
      alert('Acesso negado: não tem permissões de administrador');
      navigate('/dashboard');
      return;
    }

    // Se não tiver feito login admin, redirecionar para admin login
    const adminAuth = sessionStorage.getItem('admin_authenticated');
    if (!loading && user && user.isAdmin && !adminAuth) {
      navigate('/backoffice/login');
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-gray-600">A verificar permissões...</div>
      </div>
    );
  }

  // Verificações finais
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isAdmin) return <Navigate to="/dashboard" replace />;
  
  const adminAuth = sessionStorage.getItem('admin_authenticated');
  if (!adminAuth) return <Navigate to="/backoffice/login" replace />;

  return children;
};

export default ProtectedAdminRoute;